import { ProductMenu } from "../../__generated__/graphql";
import TransitionWrapper from "../common/transition-wrapper";
import MenuImageSlider from "../order/menu-image-slider";
import { HiShoppingCart } from "react-icons/hi"; // 장바구니 아이콘 추가

interface ProductCardProps {
  product: {
    id: number;
    name: string;
    img?: string | null;
    menus?: ProductMenu[] | null;
    price: number;
    userPrice: number;
    currentCount: number;
    isEnd: boolean;
    isSampleMenu: boolean;
    isDeleted: boolean;
    isSoldout: boolean;
  };
  onClickProduct: (
    product: {
      id: number;
      name: string;
      userPrice: number;
      price: number;
    },
    isAddToCart?: boolean
  ) => void;
  cartQuantity?: number;
}

export default function ProductCard({
  product,
  onClickProduct,
  cartQuantity = 0,
}: ProductCardProps) {
  const isInCart = cartQuantity > 0;
  if (product.isDeleted) {
    return null;
  }

  return (
    <TransitionWrapper
      scale={0.95}
      opacity={0.8}
      className="w-full flex p-3 rounded-[0.625rem] overflow-hidden border border-[#F9F9F9] bg-white shadow-[0_3px_8px_0_rgba(0,0,0,0.05)]"
    >
      <div className="relative w-[110px] h-[110px] shrink-0 rounded-lg overflow-hidden">
        <MenuImageSlider
          onClick={() =>
            product.currentCount > 0 &&
            !product.isEnd &&
            onClickProduct(
              {
                id: product.id,
                name: product.name,
                userPrice: product.userPrice || 0,
                price: product.price,
              },
              false
            )
          }
          productImage={product.img}
          menus={product.menus}
        />
        {product.isEnd && product.currentCount !== 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-l-lg">
            <span className="text-white text-xl font-semibold">판매종료</span>
          </div>
        )}
        {product.currentCount <= 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-l-lg">
            <span className="text-white text-xl font-semibold">품절</span>
          </div>
        )}
        {product.isSampleMenu && (
          <div className="absolute top-2 left-2 bg-pink-500 px-2 py-1 flex items-center justify-center rounded-lg">
            <span className="text-white text-base font-semibold">이벤트</span>
          </div>
        )}
        {isInCart && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-l-lg z-10">
            <div className="flex flex-col items-center">
              <HiShoppingCart className="text-[#1569fc] text-3xl" />
              <span className="text-white text-sm font-bold mt-0.5">
                x {cartQuantity}
              </span>
            </div>
          </div>
        )}
      </div>

      <div
        onClick={() =>
          product.currentCount > 0 &&
          !product.isEnd &&
          onClickProduct(
            {
              id: product.id,
              name: product.name,
              userPrice: product.userPrice || 0,
              price: product.price,
            },
            false
          )
        }
        className="pl-4 w-full h-full flex flex-col justify-between"
      >
        <div className="text-black text-lg font-semibold">{product.name}</div>
        <div className="text-sm font-medium text-[#1569fc] mt-1">
          {product.currentCount < 0 ? 0 : product.currentCount}개 남았어요!
        </div>
        {product.currentCount > 0 && !product.isEnd && (
          <div className="mt-1 w-full flex items-center justify-between">
            <div className="flex flex-col items-start justify-center">
              <div className="text-sm text-red-400 line-through font-semibold">
                {product.price.toLocaleString()}원
              </div>
              <div className="text-lg text-black font-bold">
                {product.userPrice?.toLocaleString()}원
              </div>
            </div>
            <button
              className={`ml-2 px-4 py-1.5 border rounded text-sm font-medium whitespace-nowrap shrink-0 transition-colors ${
                isInCart
                  ? "bg-red-500 border-red-500 text-white hover:bg-red-600"
                  : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
              }`}
              onClick={(e) => {
                e.stopPropagation();
                onClickProduct(
                  {
                    id: product.id,
                    name: product.name,
                    userPrice: product.userPrice || 0,
                    price: product.price,
                  },
                  true
                );
              }}
            >
              {isInCart ? "빼기" : "담기"}
            </button>
          </div>
        )}
      </div>
    </TransitionWrapper>
  );
}
